import type { BatchData } from '../types';

export interface BatchStats {
  ingredientCount: number;
  totalWeight: number;
  phaseCount: number;
  percents: number[];
}

export function computeBatchStats(b: BatchData): BatchStats {
  const rows = b.rows ?? [];
  const filled = rows.filter((r) => r.ingredient.trim());
  const total = rows.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);
  const phases = new Set(filled.map((r) => r.phase));
  const percents = rows.map((r) =>
    total > 0 ? ((parseFloat(r.amount) || 0) / total) * 100 : 0,
  );
  return {
    ingredientCount: filled.length,
    totalWeight: total,
    phaseCount: phases.size,
    percents,
  };
}
